import {PILL_DISABLED_DUE_TO_DOWNSTREAM_FLAG_ROWS} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {checkCanInsertStep} from 'analysis-tool/EditStepHelpers';
import getDataFrameFilterOptions from 'analysis-tool/filters/GetDataFrameFilterOptions';
import getViewBasedDataFrameFilterOptions from 'analysis-tool/filters/GetViewBasedDataFrameFilterOptions';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {DataReference} from 'analysis-tool/ui/main-view/MainViewTypes';
import {DataFrameHeaderMenuOptions} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {DataFrameReadOnlyInfo} from 'data-frames/header-menu/DataFrameReadOnlyInfo';
import hasDownstreamFlagRowsStep from 'pipelines/hasDownstreamFlagRowsStep';
import {PipelineViewGraphQL} from 'pipelines/PipelineTypes';

import {RightSidebarItemState} from './DataFrameHeaderMenuUtil';
import {getHideColumnOptions} from './GetDataFrameHideColumnOptions';
import {getRenameColumnOptions} from './GetDataFrameRenameColumnOptions';
import {getRetypeColumnOptions} from './GetDataFrameRetypeColumnOptions';

export function getReadOnlyInfo(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep,
  inputDataFrameId?: string
): DataFrameReadOnlyInfo {
  if (isAnalysisReadOnly(analysis)) {
    return {isReadOnly: true};
  }

  if (hasDownstreamFlagRowsStep(analysis, step)) {
    return {
      isReadOnly: true,
      allUpdatesDisabledMessage: PILL_DISABLED_DUE_TO_DOWNSTREAM_FLAG_ROWS,
    };
  }

  const {canEdit, message} = checkCanInsertStep(analysis, step.id, 'table', inputDataFrameId);

  return canEdit ? {isReadOnly: false} : {isReadOnly: false, allUpdatesDisabledMessage: message};
}

export function getDataFrameHeaderMenuOptions(
  analysis: AnalysisGraphQL,
  view: PipelineViewGraphQL | null,
  analysisClientStateId: string,
  step: GetAnalysisPipelineStep,
  inputDataReference: DataReference,
  inputDataFrameId?: string,
  outputDataReferences?: Array<DataReference>,
  rightSidebarItemState?: RightSidebarItemState
): DataFrameHeaderMenuOptions {
  return {
    readOnlyInfo: getReadOnlyInfo(analysis, step, inputDataFrameId),
    filterOptions:
      view != null
        ? getViewBasedDataFrameFilterOptions(analysis, analysisClientStateId, view)
        : getDataFrameFilterOptions(
            analysis,
            step,
            inputDataReference,
            inputDataFrameId,
            outputDataReferences,
            rightSidebarItemState
          ),
    hideColumnOptions: getHideColumnOptions(
      analysis,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences,
      rightSidebarItemState
    ),
    renameColumnOptions: getRenameColumnOptions(
      analysis,
      analysisClientStateId,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences,
      rightSidebarItemState
    ),
    retypeColumnOptions: getRetypeColumnOptions(
      analysis,
      analysisClientStateId,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences,
      rightSidebarItemState
    ),
  };
}
